import { Controller } from "@hotwired/stimulus"

// Generic dropdown controller for any toggle menu
// Replaces: profile_dropdown_controller.js, date_filter_dropdown_controller.js
export default class extends Controller {
  static targets = ["menu", "trigger"]
  static values = {
    open: { type: Boolean, default: false }
  }

  connect() {
    this.boundClickOutside = this.clickOutside.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClickOutside)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    this.openValue = !this.openValue
  }

  open() {
    this.openValue = true
  }

  close() {
    this.openValue = false
  }

  openValueChanged() {
    if (this.openValue) {
      this.menuTarget.classList.remove("hidden")
      if (this.hasTriggerTarget) {
        this.triggerTarget.setAttribute("aria-expanded", "true")
      }
      document.addEventListener("click", this.boundClickOutside)
    } else {
      this.menuTarget.classList.add("hidden")
      if (this.hasTriggerTarget) {
        this.triggerTarget.setAttribute("aria-expanded", "false")
      }
      document.removeEventListener("click", this.boundClickOutside)
    }
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}
